<div class="attributes attributes--tags">
  <ng-content select="[heading]" />
  <rt-attributes
    (query)="tagTypeaheadUpdate($event)"
    (save)="save.emit($event)"
    (delete)="delete.emit($event)"
    (loadMore)="tagLoadMore($event)"
    [translationsContext]="'tags'"
    [canPick]="tags().editable!"
    [canRemove]="tags().editable!"
    [canCreate]="tags().writable!"
    [attributes]="tags().value!"
    [suggestionsData]="$any(tagsTypeahead)"
    [hasMarginTop]="true"
    [hasSmallXXXMargins]="true"
    [hasTagsFontWeightMedium]="true"
    [selectHeaderTemplate]="tagsHeaderTemplate"
    [tagsHoverable]="false"
    [tagsClickable]="false"
    [itemsLimit]="limitItems() ? displayLimit : undefined"
    [triggerIconButtonVariant]="createIconButtonVariant()"
    [showMoreButtonVariant]="showMoreButtonVariant()"
    [hasValueTooltipMinLength]="40"
  />
  @if (withEmptyState() && !tags().value?.length && !tags().editable!) {
    <rt-icon name="remove" colorToken="colorIconDisabled" />
  }
</div>

<ng-template #tagsHeaderTemplate>
  <rt-dropdown-header>
    {{ 'app.common.placeholders.search.tags.other' | translate }}
    <a
      rt-icon-button
      suffix
      iconName="settings"
      size="small"
      variant="plain"
      [routerLink]="['/settings/tags']"
      [queryParams]="{ tab: 'candidateTags' }"
    ></a>
  </rt-dropdown-header>
</ng-template>
